import alt from '../alt';


class CandidateActions {
    constructor() {
        this.generateActions(
            'getCandidatesSuccess', 'getCandidatesFailed', 'getPotentialCandidatesSuccess', 'mergeErrorsIntoState',
            'getSaveProfileSuccess', 'getCandidateSuccess', 'getCandidateFailed', 'getUpdateCandidateDatesFailed',
            'getUpdateCandidateDatesSuccess', 'getPotentialCandidatesFailed', 'saveProfileFailed', 'clearCandidates'
        );
    }

    updateCandidateHiring(hiring) {
        this.dispatch(hiring);
    }
}

export default alt.createActions(CandidateActions);



/** WEBPACK FOOTER **
 ** ./app/src/actions/CandidateActions.js
 **/